/**
 * Page-load milestones as User Timing marks (`load:<name>`), so a load can be read back with
 * `performance.getEntriesByType('mark').filter((m) => m.name.startsWith('load:'))` or seen in the
 * Performance panel. Each name is marked once per page load (the first time it happens), so marks
 * never accumulate over a long session. `localStorage['debug:load'] = '1'` also logs them.
 */

const seen = new Set<string>()
const log = (() => {
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem('debug:load') === '1'
  } catch {
    return false
  }
})()

export function loadMark(name: string, detail?: unknown): void {
  if (seen.has(name) || typeof performance === 'undefined' || !performance.mark) return
  seen.add(name)
  try {
    performance.mark(`load:${name}`, detail === undefined ? undefined : { detail })
  } catch {
    // ignore
  }
  if (log) console.info(`[load] ${name} @ ${performance.now().toFixed(0)} ms`, detail ?? '')
}

/** Lets a milestone be marked again (e.g. a document opened again by navigation). */
export function resetLoadMarks(prefix: string): void {
  for (const name of [...seen]) if (name.startsWith(prefix)) seen.delete(name)
}
